export const BOB_CLIENTS_DETAILS = "BOB_CLIENTS_DETAILS";
export const BOB_CLIENTS_DETAILS_FAILED = "BOB_CLIENTS_DETAILS_FAILED";
export const BOB_CLIENTS_BILLING_DETAILS = "BOB_CLIENTS_BILLING_DETAILS";
export const BOB_CLIENTS_BILLING_DETAILS_FAILED = "BOB_CLIENTS_BILLING_DETAILS_FAILED";
export const BOB_CLIENTS_COVERAGE_DETAILS = "BOB_CLIENTS_COVERAGE_DETAILS";
export const BOB_CLIENTS_COVERAGE_DETAILS_FAILED = "BOB_CLIENTS_COVERAGE_DETAILS_FAILED";
export const BOB_CLIENTS_DEPENDENT_DETAILS = "BOB_CLIENTS_DEPENDENT_DETAILS";
export const BOB_CLIENTS_DEPENDENT_DETAILS_FAILED = "BOB_CLIENTS_DEPENDENT_DETAILS_FAILED";
export const UPDATE_TAB_INDEX = "UPDATE_TAB_INDEX";
export const UPDATE_EMP_FILTER = "UPDATE_EMP_FILTER"
export const RESET_CLIENTS_SUMMARY = "RESET_CLIENTS_SUMMARY";
export const SET_CLIENT_USERAGENT_DETAILS = "SET_CLIENT_USERAGENT_DETAILS";
export const SET_CLIENT_USERAGENT_DETAILS_LOADING = "SET_CLIENT_USERAGENT_DETAILS_LOADING";
export const CLIENT_USERAGENT_FETCH_FAILED = "CLIENT_USERAGENT_FETCH_FAILED";